import {interopDefault} from '@/utils/helpers'

const InsuranceSearchPage = () => interopDefault(import('~/pages/insurance/InsuranceSearchPage'))
const InsuranceBookingPage = () => interopDefault(import('~/pages/insurance/InsuranceBookingPage'))
const InsuranceConfirmationPage = () => interopDefault(import('~/pages/insurance/InsuranceConfirmationPage'))

export default [
    {
        path: '/search/insurance',
        component: InsuranceSearchPage,
        name: 'insuranceSearch',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/insurance/booking',
        component: InsuranceBookingPage,
        name: 'insuranceBooking',
        meta: {
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/insurance/confirmation',
        component: InsuranceConfirmationPage,
        name: 'insuranceConfirmation',
        meta: {
            unwrapped: true,
        },
    },
]
